export const categoryConstants = {
  GETALL_REQUEST: 'CATEGORY_GETALL_REQUEST',
  GETALL_SUCCESS: 'CATEGORY_GETALL_SUCCESS',
  GETALL_FAILURE: 'CATEGORY_GETALL_FAILURE',
  GETALL_LOADING: 'CATEGORY_GETALL_LOADING',

  CREATE_REQUEST: 'CATEGORY_CREATE_REQUEST',
  CREATE_SUCCESS: 'CATEGORY_CREATE_SUCCESS',
  CREATE_FAILURE: 'CATEGORY_CREATE_FAILURE',
  CREATE_LOADING: 'CATEGORY_CREATE_LOADING',

  GET_REQUEST: 'CATEGORY_GET_REQUEST',
  GET_SUCCESS: 'CATEGORY_GET_SUCCESS',
  GET_FAILURE: 'CATEGORY_GET_FAILURE',
  GET_LOADING: 'CATEGORY_GET_LOADING',

  UPDATE_REQUEST: 'CATEGORY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'CATEGORY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'CATEGORY_UPDATE_FAILURE',
  UPDATE_LOADING: 'CATEGORY_UPDATE_LOADING',

  DELETE_REQUEST: 'CATEGORY_DELETE_REQUEST',
  DELETE_SUCCESS: 'CATEGORY_DELETE_SUCCESS',
  DELETE_FAILURE: 'CATEGORY_DELETE_FAILURE',
  DELETE_LOADING: 'CATEGORY_DELETE_LOADING',
}